import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeCustomerStatusProps } from '../types/interfaces'

import { Status as CustomerStatus } from '@brighterly/lib-core-types/customer/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeCustomerStatusOptions {
  props: BadgeCustomerStatusProps
}

interface BadgeCustomerStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<CustomerStatus, AppBadgeColor>> = {
  [CustomerStatus.Draft]: 'slate',
  [CustomerStatus.Lead]: 'slate',
  [CustomerStatus.LeadConfirmed]: 'slate',
  [CustomerStatus.LeadNoShow]: 'red',
  [CustomerStatus.LeadCompleted]: 'emerald',
  [CustomerStatus.Deal]: 'blue',
}

export const useBadgeCustomerStatus = ({ props }: BadgeCustomerStatusOptions): BadgeCustomerStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<CustomerStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.customer.status,
  })
}
